export default __webpack_public_path__ + "static/media/icons_journey.8639d2e2.svg";